// @flow
import { createAction } from 'redux-actions';

export const attemptValidateToken = createAction('hive/connected-care-invite/ATTEMPT_VALIDATE_TOKEN');
export const validateToken = createAction('hive/connected-care-invite/VALIDATE_TOKEN');
export const attemptAcceptInvite = createAction('hive/connected-care-invite/ATTEMPT_ACCEPT_INVITE');
export const acceptInvite = createAction('hive/connected-care-invite/ACCEPT_INVITE');



// WEBPACK FOOTER //
// ./src/core/state/connected-care-invite/actions.js